/* ------------------------------------ - ----------------------------------- */
import {TranslateService} from '@ngx-translate/core';

import {ObjectBuildAvailablePlaceholder, ObjectBuildType} from './shared.types';

/* ------------------------------------ - ----------------------------------- */

export type ObjectDataLabel = string;

export type ObjectBuildPair<D extends ObjectDataLabel = ObjectDataLabel> = {
	index: number; // the index of the pair in the array
	data_label: D; // the label string that the user type that defines the expected data (in selected placeholder)
	selected_placeholder: ObjectBuildAvailablePlaceholder; // the selected placeholder object
	value?: string; // only for constant placeholders
	output_placeholder: ObjectBuildType[D]; // the output placeholder string
};

export function emptyCustomDataObjectFactory(translate: TranslateService): () => ObjectBuildAvailablePlaceholder {
	return () => ({
		source: 'const',
		key: '',
		label: translate.instant('components.simple_object_builder.custom_data'),
		icon: 'edit_note',
	});
}
